export default __webpack_public_path__ + "static/media/loader-bui.0532a871.gif";